import defineRule from '../defineRule';
defineRule('passwordMatch', (value, [target]) => {
    return value === target || 'This field must match your new password';
});
